import { FormDynamic } from "src/shared/interface/form-dynamic";

export const FormCampanas: FormDynamic = {
  id: "master",
  name: "Formulario Brief Campañas",
  user: "masteradmin@bancolombia.com.co",
  fields: [
    {
      label: "¿A qué nivel pertenece la campaña?",
      item: "nivel",
      type: "select",
      isRequired: true,
      placeholder: "Indica el nivel de la pirámide",
      options: [
        {
          value: "N1",
          name: "Nivel 1",
        },
        {
          value: "N21",
          name: "Nivel 2.1",
        },
        {
          value: "N22",
          name: "Nivel 2.2",
        },
        {
          value: "N3",
          name: "Nivel 3",
        },
      ],
    },
    {
      label: "¿Cuál es el nombre de la campaña?",
      item: "name",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese el nombre de la campaña",
    },
    {
      label: "Indica nomenclatura para facturación:",
      item: "nomenclatura",
      type: "select",
      isRequired: true,
      placeholder: "Ejemplo: HUMANIDAD_EST_MARCA_MDO01055_MEDIA TEAM",
      options: [
        {
          name: "Agro - MDO01057",
          value: "AGROPLATOSDETEMPORADA_EST_ATRACCIÓN_MDO01057_MEDIATEAM",
        },
        {
          name: "Ciclo de negocio - MDO01062",
          value: "CICLODENEGOCIO_EST_ATRACCIÓN_MDO01062_MEDIATEAM",
        },
        {
          name: "Nomina - MDO01063",
          value: "NOMINA_EST_ATRACCIÓN_MDO01063_MEDIATEAM",
        },
        {
          name: "Pricing - MDO01065",
          value: "PRICING_EST_ATRACCIÓN_MDO01065_MEDIATEAM",
        },
        {
          name: "Pensionados - MDO01064",
          value: "PENSIONADOS_EST_ATRACCIÓN_MDO01064_MEDIATEAM",
        },
        {
          name: "Inversiones - MDO01077",
          value: "INVERSIONES_EST_ATRACCIÓN_MDO01077_MEDIATEAM",
        },
        {
          name: "Independientes - MDO01078",
          value: "INDEPENDIENTES_EST_ATRACCIÓN_MDO01078_MEDIATEAM",
        },
        {
          name: "Consumo y preaprobado - MDO01097",
          value: "CONSUMOYPREAPROBADO_EST_ATRACCIÓN_MDO01097_MEDIATEAM",
        },
        {
          name: "Cuenta de Ahorros - MDO00862",
          value: "CUENTASDEAHORRO_VD_MDO00862_VENTASDIGITALES",
        },
        {
          name: "Bancolombia A la mano - MDO00859",
          value: "BANCOLOMBIAALAMANO_VD_MDO00859_VENTASDIGITALES ",
        },
        {
          name: "Cuentas de Ahorro Panamá - MDO00862",
          value: "CTASDEAHORROPANAMA_VD_MDO00862_VENTASDIGITALES",
        },
        {
          name: "Inversion virtual - MDO00863",
          value: "INVERSIÓNVIRTUAL_VD_MDO00863_VENTASDIGITALES",
        },
        {
          name: "Fondos de Inversion - MDO00861",
          value: "FONDOSDEINVERSIÓN_VD_MDO00861_VENTASDIGITALES",
        },
        {
          name: "TDC - Preaprobados - MDO00855",
          value: "TDCPREAPROBADOS_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "TDC - Solicitudes web - MDO00855",
          value: "TDCSOLICITUDESWEB_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "E-Card - MDO00855",
          value: "E-CARD_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "Libre Inversion - Preaprobados - MDO00856",
          value: "LIBREINVERSIÓNPREAPROBADOS_VD_MDO00856_VENTASDIGITALES",
        },
        {
          name: "Libre inversion - Solicitudes web - MDO00856",
          value: "LIBREINVERSIÓNSOLICITUDESWEB_VD_MDO00856_VENTASDIGITALES",
        },
        {
          name: "Libranza - MDO00857",
          value: "LIBRANZA_VD_MDO00857_VENTASDIGITALES",
        },
        {
          name: "Crediagil - MDO00858",
          value: "CREDIAGIL_VD_MDO00858_VENTASDIGITALES",
        },
        {
          name: "Hipotecario - MDO01041",
          value: "HIPOTECARIO_VD_MDO01041_VENTASDIGITALES",
        },
        {
          name: "Seguro Mascotas - MDO00864",
          value: "SEGUROMASCOTAS_VD_MDO00864_VENTASDIGITALES",
        },
        {
          name: "A la mano (Media Team) - MDO01073",
          value: "ALAMANO_VD_MDO01073_MEDIATEAM",
        },
        {
          name: "Colombianos en el exterior (Media Team) - MDO01099",
          value: "COLOMBIANOSENELEXTERIOR_VD_MDO01099_MEDIATEAM",
        },
        {
          name: "Gamming (Media team) - MDO01103",
          value: "GAMMING_VD_MDO01103_MEDIATEAM",
        },
        {
          name: "Remesas (Media team) - MDO01104",
          value: "REMESAS_VD_MDO01104_MEDIATEAM",
        },
        {
          name: "Tarjeta de crédito única - MDVD0001",
          value:
            "TARJETAUNICA_VD_MDO1108_VENTASDIGITALES (ORDEN INTERNA NO EXISTE MANEJO PROPIO TEMPORAL)",
        },
        {
          name: "Encadenamientos Productivos - MDO01066",
          value: "ENCADENAMIENTOS_EST_USO_MDO01066_MEDIATEAM ",
        },
        { name: "Pyme - MDO01067", value: "PYME_EST_USO_MDO01067_MEDIATEAM" },
        {
          name: "Endeudamiento responsable - MDO01076",
          value: "ENDEUDAMIENTO_EST_USO_MDO01076_MEDIATEAM",
        },
        {
          name: "Movilidad Pública - MDO01079",
          value: "MOVILIDADPUBLICA_EST_USO_MDO01079_MEDIATEAM",
        },
        {
          name: "Aceptación Comercios  - MDO01080",
          value: "ACEPTACIONCOMERCIOS_EST_USO_MDO01080_MEDIATEAM",
        },
        {
          name: "Recaudos y pagos de facturas - MDO01081",
          value: "RECAUDOS_EST_USO_MDO01081_MEDIATEAM",
        },
        {
          name: "Dirección y adopción digital - MDO01105",
          value: "ADOPCIONDIGITAL_EST_USO_MDO01105_MEDIATEAM",
        },
        {
          name: "Ofertas y Alianzas - MDO01087",
          value: "OFERTASYALIANZAS_EST_USO_MDO01087_MEDIATEAM",
        },
        {
          name: "Bank as service - MDO01089",
          value: "BAAS_EST_USO_MDO01089_MEDIATEAM",
        },
        {
          name: "Factoring  - MDO01092",
          value: "FACTORING_EST_USO_MDO01092_MEDIATEAM",
        },
        {
          name: "Impuestos - MDO01093",
          value: "IMPUESTOS_EST_USO_MDO01093_MEDIATEAM",
        },
        {
          name: "Comercios internacionales - MDO01094",
          value: "COMERCIOSINTERNACIONALES_EST_USO_MDO01094_MEDIATEAM",
        },
        {
          name: "Día a Día  - MDO01098",
          value: "DIAADIA_EST_USO_MDO01098_MEDIATEAM",
        },
        {
          name: "Humanidad - MDO01055",
          value: "HUMANIDAD_EST_MARCA_MDO01055_MEDIATEAM",
        },
        {
          name: "Sostenibiliad - Poseidón - MDO01056",
          value: "SOSTENIBILIDAD_EST_MARCA_MDO01056_MEDIATEAM",
        },
        {
          name: "Fútbol - MDO01084",
          value: "FUTBOL_EST_MARCA_MDO01084_MEDIATEAM",
        },
        {
          name: "Bienestar financiero - MDO01074",
          value: "BIENESTARFINANCIERO_EST_MARCA_MDO01074_MEDIATEAM",
        },
        {
          name: "Des-enredados  - MDO01106",
          value: "DES-ENREDADOS_EST_MARCA_MDO01106_MEDIATEAM",
        },
        {
          name: " Preferencial y banca privada   - MDO01068",
          value: "PREFERENCIALYBCAPRIVADA_EST_FIDELIZACIÓN_MDO01068_MEDIATEAM",
        },
        {
          name: "Fidelización - MDO01070",
          value: "FIDELIZACIÓN_EST_FIDELIZACIÓN_MDO01070_MEDIATEAM",
        },
        {
          name: "Puntos Colombia - MDONEGOCIO",
          value: "PUNTOSCOLOMBIA_EST_FIDELIZACIÓN_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "Seguros - MDONEGOCIO",
          value: "SEGUROS_EST_FIDELIZACIÓN_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "Plus Alto - MDONEGOCIO",
          value: "PLUSALTO_EST_FIDELIZACION_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "TU360 Awarness  - MDO1109",
          value: "TU360MARCA_ECOSISTEMAS_MDO01109_MEDIATEAM",
        },
        {
          name: "Tu360 Inmobiliario, vivienda y constructor - MDO01072",
          value: "TU360INMOBILIARIO_ECOSISTEMAS_MDO01072_MEDIATEAM",
        },
        {
          name: "Tu360 Compras - MDO01082",
          value: "TU360COMPRAS_ECOSISTEMAS_MDO01082_MEDIATEAM",
        },
        {
          name: "Tu360 Movilidad - MDO01083",
          value: "TU360MOVILIDAD_ECOSISTEMAS_MDO01083_MEDIATEAM",
        },
        {
          name: "Tu360 Negocios - MDO01102",
          value: "TU360NEGOCIOS_ECOSISTEMAS_MDO01102_MEDIATEAM",
        },
      ],
    },
    {
      label: "¿A qué marca pertenece la campaña?",
      item: "marca",
      type: "multi_select",
      isRequired: true,
      placeholder: "la marca a generar la campaña",
      options: [
        {
          value: "bancolombia",
          name: "Bancolombia",
        },
        {
          value: "bancoagricola",
          name: "Bancoagricola",
        },
        {
          value: "banistmo",
          name: "Banitmo",
        },
        {
          value: "bam",
          name: "Bam",
        },
        {
          value: "renting colombia",
          name: "Renting Colombia",
        },
        {
          value: "nequi",
          name: "Nequi",
        },
      ],
    },
    {
      label:
        "¿A que ciclo de vida de mercadeo pertenece la campaña/iniciativa?",
      item: "ciclo",
      type: "multi_select",
      isRequired: true,
      placeholder: "el ciclo de vida",
      options: [
        {
          name: "Uso",
          value: "uso",
        },
        {
          name: "Atracción y Profundización",
          value: "atraccion y profundizacion",
        },
        {
          name: "Integración del Usuario",
          value: "integración del usuario",
        },
        {
          name: "Ecosistemas",
          value: "ecosistemas",
        },
        {
          name: "Ventas Digitales",
          value: "ventas digitales",
        },
        {
          name: "Marca",
          value: "marca",
        },
        {
          name: "Fidelización",
          value: "fidelizacion",
        },
      ],
    },
    {
      label: "¿Cuándo inicia la campaña?",
      item: "fecha_inicio",
      type: "date",
      isRequired: false,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "¿Cuándo termina la campaña?",
      item: "fecha_fin",
      type: "date",
      isRequired: false,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "Objetivo de mercadeo:",
      item: "objetivo",
      type: "array_fields",
      isRequired: false,
        arrayFields: [
          {
            type: "textarea",
            label: "Objetivo",
            item: "objetivo",
            isRequired: true,
            placeholder: "Se debe escribir el objetivo macro que tiene el producto /gerencia, el que aparece en el One-page.",
          },
        ]
    },
    {
      label: "KRs",
      item: "krs",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Si aplica, por favor menciona el KR específico al cual le aportará este proyecto/campaña y el Q al que corresponde.",
    },
    {
      label: "Estrategia macro",
      item: "estrategia_macro",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Se debe escribir la estrategia macro que tiene el producto / gerencia, la que aparece en el One-page",
    },
    {
      label:
        "¿A quién le vamos a hablar con esta campaña? Market place (adressable): ",
      item: "adressable",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Menciona la audiencia identificada desde el market place a la cuál el vamos a hablar.",
    },
    {
      label:
        "¿A quién le vamos a hablar con esta campaña? Perfil de la audiencia / Buyer Persona ",
      item: "audiencia",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Realiza una breve descripción comportamental de las personas a las que les queremos hablar ",
    },
    {
      label: "¿Cuál es el atributo de marca asociado a esta campaña? ",
      item: "seasonality_mode",
      type: "multi_select",
      options: [
        {
          value: "capilaridad",
          name: "Capilaridad",
        },
        {
          value: "calidad",
          name: "Calidad",
        },
        {
          value: "transparencia",
          name: "Transparencia",
        },
        {
          value: "sostenibilidad",
          name: "Sostenibilidad",
        },
      ],
      isRequired: false,
      placeholder: "siguientes opciones",
    },
    {
      label:
        "¿Qué espera que la audiencia piense, haga o sienta después de estar expuesta / tener contacto con esta comunicación?",
      item: "audiencia_piensa",
      type: "textarea",
      isRequired: false,
      placeholder: "Que piensa la audiencia",
    },
    {
      label:
        "¿Por qué hoy esto no pasa? ¿Qué impide a nuestra audiencia hacer, pensar o sentir esto? ",
      item: "hoy_no",
      type: "textarea",
      isRequired: false,
      placeholder: "Hoy no esta por ....",
    },
    {
      label:
        "¿Qué tenemos para ofrecer que los motive a hacer lo que queremos que hagan, piense o sienta? (diferencial, beneficio, RTB)",
      item: "que_tenemos",
      type: "textarea",
      isRequired: false,
      placeholder: "Ofrecemos ....",
    },
    {
      label:
        "¿Existe algún competidor local y/o global que esté ofreciendo lo mismo o un producto sustituto y en su criterio lo esté haciendo bien? ¿Cuál? ¿Qué está haciendo? ¿por qué lo está haciendo bien? ",
      item: "competidor_local",
      type: "textarea",
      isRequired: false,
      placeholder: "Nuestros competidores ....",
    },
    {
      label: "Objetivos de medios",
      item: "objetivos_medios",
      type: "array_fields",
      isRequired: false,
      arrayFields: [
        {
          type: "select",
          label: "Tipo de objetivo",
          item: "type",
          isRequired: true,
          placeholder: "Tipo de objetivo",
          options: [
            {
              value: "branding",
              name: "Branding",
            },
            {
              value: "performance",
              name: "Performance",
            },
          ],
        },
        {
          type: "select",
          label: "Etapa",
          item: "etapa",
          isRequired: true,
          placeholder: "Etapa",
          options: [
            {
              value: "awareness",
              name: "Awareness",
            },
            {
              value: "consideracion",
              name: "Consideración",
            },
            {
              value: "conversion",
              name: "Conversión ¿Dónde se cierra la conversión?",
            },
          ],
        },
        {
          type: "textarea",
          label: "Objetivos",
          item: "objetivos",
          isRequired: true,
          placeholder: "Objetivos",
          options: [
            {
              value: "posiciomiento",
              name: "Posicionamiento de marca",
            },
            {
              value: "alcance",
              name: "Alcance",
            },
            {
              value: "trafico",
              name: "Trafico al sitio",
            },
            {
              value: "interacciones",
              name: "Interacciones con los anuncios",
            },
            {
              value: "videos",
              name: "Reproducciones de videos",
            },
            {
              value: "lead",
              name: "Lead",
            },
          ],
        },
      ],
    },
    {
      label: "Presupuesto medios",
      item: "presupuesto_medios",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese presupuesto",
    },
    {
      label: "Presupuesto producciones",
      item: "presupuesto_producciones",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese presupuesto",
    },
    {
      label: "¿A que MDO se carga el ppto?",
      item: "presupuesto_owner",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese el owner presupuesto",
    },
    {
      label:
        "¿Qué equipos (internos y externos) van a participar en este proceso? ¿Cuál es el rol de cada uno?",
      item: "equipo",
      type: "textarea",
      isRequired: true,
      placeholder: "Ingrese el equipo",
    },
    {
      label:
        "¿Para que países se requiren los derechos para utilizar las piezas de la campaña?",
      item: "paises",
      type: "multi_select",
      isRequired: true,
      placeholder: "Agrega el pais",
      options: [
        {
          name: "Colombia",
          value: "colombia",
        },
        {
          name: "Panama",
          value: "panama",
        },
        {
          name: "Guatemala",
          value: "guatemala",
        },
        {
          name: "Salvador",
          value: "salvador",
        },
      ],
    },
    {
      label:
        "¿Por cuánto tiempo se utilizarán las piezas de la campaña/iniciativa?",
      item: "tiempo",
      type: "textarea",
      isRequired: true,
      placeholder: "Ingrese el tiempo de la campaña",
    },
    {
      label: "Pre-read de negocio y producto",
      item: "preread",
      type: "file",
      isRequired: true,
      placeholder:
        "se puede adjuntar un documento conciso con la información de contexto, de negocio y/o de producto que considere se debe tener en cuenta antes de leer el brief.",
    },
    {
      label: "One page",
      item: "onepage",
      type: "file",
      isRequired: true,
      placeholder: "por favor adjunta el One Page de esta iniciativa",
    },
  ],
  version: 1,
  dateCreate: new Date().toDateString(),
  dateEdit: new Date().toDateString(),
};

export const FormInitiative: FormDynamic = {
  id: "master",
  name: "Formulario Brief Iniciativa",
  user: "masteradmin@bancolombia.com.co",
  fields: [
    {
      label: "¿A qué nivel pertenece la iniciativa?",
      item: "nivel",
      type: "select",
      isRequired: true,
      placeholder: "Indica el nivel de la pirámide",
      options: [
        {
          value: "N1",
          name: "Nivel 1",
        },
        {
          value: "N21",
          name: "Nivel 2.1",
        },
        {
          value: "N22",
          name: "Nivel 2.2",
        },
        {
          value: "N3",
          name: "Nivel 3",
        },
      ],
    },
    {
      label: "¿Cuál es el nombre de la iniciativa?",
      item: "name",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese el nombre de la iniciativa",
    },
    {
      label: "Indica nomenclatura para facturación:",
      item: "nomenclatura",
      type: "select",
      isRequired: true,
      placeholder: "Ejemplo: HUMANIDAD_EST_MARCA_MDO01055_MEDIA TEAM",
      options: [
        {
          name: "Agro - MDO01057",
          value: "AGROPLATOSDETEMPORADA_EST_ATRACCIÓN_MDO01057_MEDIATEAM",
        },
        {
          name: "Ciclo de negocio - MDO01062",
          value: "CICLODENEGOCIO_EST_ATRACCIÓN_MDO01062_MEDIATEAM",
        },
        {
          name: "Nomina - MDO01063",
          value: "NOMINA_EST_ATRACCIÓN_MDO01063_MEDIATEAM",
        },
        {
          name: "Pricing - MDO01065",
          value: "PRICING_EST_ATRACCIÓN_MDO01065_MEDIATEAM",
        },
        {
          name: "Pensionados - MDO01064",
          value: "PENSIONADOS_EST_ATRACCIÓN_MDO01064_MEDIATEAM",
        },
        {
          name: "Inversiones - MDO01077",
          value: "INVERSIONES_EST_ATRACCIÓN_MDO01077_MEDIATEAM",
        },
        {
          name: "Independientes - MDO01078",
          value: "INDEPENDIENTES_EST_ATRACCIÓN_MDO01078_MEDIATEAM",
        },
        {
          name: "Consumo y preaprobado - MDO01097",
          value: "CONSUMOYPREAPROBADO_EST_ATRACCIÓN_MDO01097_MEDIATEAM",
        },
        {
          name: "Cuenta de Ahorros - MDO00862",
          value: "CUENTASDEAHORRO_VD_MDO00862_VENTASDIGITALES",
        },
        {
          name: "Bancolombia A la mano - MDO00859",
          value: "BANCOLOMBIAALAMANO_VD_MDO00859_VENTASDIGITALES ",
        },
        {
          name: "Cuentas de Ahorro Panamá - MDO00862",
          value: "CTASDEAHORROPANAMA_VD_MDO00862_VENTASDIGITALES",
        },
        {
          name: "Inversion virtual - MDO00863",
          value: "INVERSIÓNVIRTUAL_VD_MDO00863_VENTASDIGITALES",
        },
        {
          name: "Fondos de Inversion - MDO00861",
          value: "FONDOSDEINVERSIÓN_VD_MDO00861_VENTASDIGITALES",
        },
        {
          name: "TDC - Preaprobados - MDO00855",
          value: "TDCPREAPROBADOS_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "TDC - Solicitudes web - MDO00855",
          value: "TDCSOLICITUDESWEB_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "E-Card - MDO00855",
          value: "E-CARD_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "Libre Inversion - Preaprobados - MDO00856",
          value: "LIBREINVERSIÓNPREAPROBADOS_VD_MDO00856_VENTASDIGITALES",
        },
        {
          name: "Libre inversion - Solicitudes web - MDO00856",
          value: "LIBREINVERSIÓNSOLICITUDESWEB_VD_MDO00856_VENTASDIGITALES",
        },
        {
          name: "Libranza - MDO00857",
          value: "LIBRANZA_VD_MDO00857_VENTASDIGITALES",
        },
        {
          name: "Crediagil - MDO00858",
          value: "CREDIAGIL_VD_MDO00858_VENTASDIGITALES",
        },
        {
          name: "Hipotecario - MDO01041",
          value: "HIPOTECARIO_VD_MDO01041_VENTASDIGITALES",
        },
        {
          name: "Seguro Mascotas - MDO00864",
          value: "SEGUROMASCOTAS_VD_MDO00864_VENTASDIGITALES",
        },
        {
          name: "A la mano (Media Team) - MDO01073",
          value: "ALAMANO_VD_MDO01073_MEDIATEAM",
        },
        {
          name: "Colombianos en el exterior (Media Team) - MDO01099",
          value: "COLOMBIANOSENELEXTERIOR_VD_MDO01099_MEDIATEAM",
        },
        {
          name: "Gamming (Media team) - MDO01103",
          value: "GAMMING_VD_MDO01103_MEDIATEAM",
        },
        {
          name: "Remesas (Media team) - MDO01104",
          value: "REMESAS_VD_MDO01104_MEDIATEAM",
        },
        {
          name: "Tarjeta de crédito única - MDVD0001",
          value:
            "TARJETAUNICA_VD_MDO1108_VENTASDIGITALES (ORDEN INTERNA NO EXISTE MANEJO PROPIO TEMPORAL)",
        },
        {
          name: "Encadenamientos Productivos - MDO01066",
          value: "ENCADENAMIENTOS_EST_USO_MDO01066_MEDIATEAM ",
        },
        { name: "Pyme - MDO01067", value: "PYME_EST_USO_MDO01067_MEDIATEAM" },
        {
          name: "Endeudamiento responsable - MDO01076",
          value: "ENDEUDAMIENTO_EST_USO_MDO01076_MEDIATEAM",
        },
        {
          name: "Movilidad Pública - MDO01079",
          value: "MOVILIDADPUBLICA_EST_USO_MDO01079_MEDIATEAM",
        },
        {
          name: "Aceptación Comercios  - MDO01080",
          value: "ACEPTACIONCOMERCIOS_EST_USO_MDO01080_MEDIATEAM",
        },
        {
          name: "Recaudos y pagos de facturas - MDO01081",
          value: "RECAUDOS_EST_USO_MDO01081_MEDIATEAM",
        },
        {
          name: "Dirección y adopción digital - MDO01105",
          value: "ADOPCIONDIGITAL_EST_USO_MDO01105_MEDIATEAM",
        },
        {
          name: "Ofertas y Alianzas - MDO01087",
          value: "OFERTASYALIANZAS_EST_USO_MDO01087_MEDIATEAM",
        },
        {
          name: "Bank as service - MDO01089",
          value: "BAAS_EST_USO_MDO01089_MEDIATEAM",
        },
        {
          name: "Factoring  - MDO01092",
          value: "FACTORING_EST_USO_MDO01092_MEDIATEAM",
        },
        {
          name: "Impuestos - MDO01093",
          value: "IMPUESTOS_EST_USO_MDO01093_MEDIATEAM",
        },
        {
          name: "Comercios internacionales - MDO01094",
          value: "COMERCIOSINTERNACIONALES_EST_USO_MDO01094_MEDIATEAM",
        },
        {
          name: "Día a Día  - MDO01098",
          value: "DIAADIA_EST_USO_MDO01098_MEDIATEAM",
        },
        {
          name: "Humanidad - MDO01055",
          value: "HUMANIDAD_EST_MARCA_MDO01055_MEDIATEAM",
        },
        {
          name: "Sostenibiliad - Poseidón - MDO01056",
          value: "SOSTENIBILIDAD_EST_MARCA_MDO01056_MEDIATEAM",
        },
        {
          name: "Fútbol - MDO01084",
          value: "FUTBOL_EST_MARCA_MDO01084_MEDIATEAM",
        },
        {
          name: "Bienestar financiero - MDO01074",
          value: "BIENESTARFINANCIERO_EST_MARCA_MDO01074_MEDIATEAM",
        },
        {
          name: "Des-enredados  - MDO01106",
          value: "DES-ENREDADOS_EST_MARCA_MDO01106_MEDIATEAM",
        },
        {
          name: " Preferencial y banca privada   - MDO01068",
          value: "PREFERENCIALYBCAPRIVADA_EST_FIDELIZACIÓN_MDO01068_MEDIATEAM",
        },
        {
          name: "Fidelización - MDO01070",
          value: "FIDELIZACIÓN_EST_FIDELIZACIÓN_MDO01070_MEDIATEAM",
        },
        {
          name: "Puntos Colombia - MDONEGOCIO",
          value: "PUNTOSCOLOMBIA_EST_FIDELIZACIÓN_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "Seguros - MDONEGOCIO",
          value: "SEGUROS_EST_FIDELIZACIÓN_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "Plus Alto - MDONEGOCIO",
          value: "PLUSALTO_EST_FIDELIZACION_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "TU360 Awarness  - MDO1109",
          value: "TU360MARCA_ECOSISTEMAS_MDO01109_MEDIATEAM",
        },
        {
          name: "Tu360 Inmobiliario, vivienda y constructor - MDO01072",
          value: "TU360INMOBILIARIO_ECOSISTEMAS_MDO01072_MEDIATEAM",
        },
        {
          name: "Tu360 Compras - MDO01082",
          value: "TU360COMPRAS_ECOSISTEMAS_MDO01082_MEDIATEAM",
        },
        {
          name: "Tu360 Movilidad - MDO01083",
          value: "TU360MOVILIDAD_ECOSISTEMAS_MDO01083_MEDIATEAM",
        },
        {
          name: "Tu360 Negocios - MDO01102",
          value: "TU360NEGOCIOS_ECOSISTEMAS_MDO01102_MEDIATEAM",
        },
      ],
    },
    {
      label: "¿A qué marca pertenece la iniciativa?",
      item: "marca",
      type: "multi_select",
      isRequired: true,
      placeholder: "la marca a generar la iniciativa",
      options: [
        {
          value: "bancolombia",
          name: "Bancolombia",
        },
        {
          value: "bancoagricola",
          name: "Bancoagricola",
        },
        {
          value: "banistmo",
          name: "Banitmo",
        },
        {
          value: "bam",
          name: "Bam",
        },
        {
          value: "renting colombia",
          name: "Renting Colombia",
        },
        {
          value: "nequi",
          name: "Nequi",
        },
      ],
    },
    {
      label: "¿A que ciclo de vida de mercadeo pertenece la iniciativa?",
      item: "ciclo",
      type: "multi_select",
      isRequired: true,
      placeholder: "el ciclo de vida",
      options: [
        {
          name: "Uso",
          value: "uso",
        },
        {
          name: "Atracción y Profundización",
          value: "atraccion y profundizacion",
        },
        {
          name: "Integración del Usuario",
          value: "integración del usuario",
        },
        {
          name: "Ecosistemas",
          value: "ecosistemas",
        },
        {
          name: "Ventas Digitales",
          value: "ventas digitales",
        },
        {
          name: "Marca",
          value: "marca",
        },
        {
          name: "Fidelización",
          value: "fidelizacion",
        },
      ],
    },
    {
      label: "¿Cuándo inicia la iniciativa?",
      item: "fecha_inicio",
      type: "date",
      isRequired: false,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "¿Cuándo termina la iniciativa?",
      item: "fecha_fin",
      type: "date",
      isRequired: false,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "Objetivo de mercadeo:",
      item: "objetivo",
      type: "array_fields",
      isRequired: false,
        arrayFields: [
          {
            type: "textarea",
            label: "Objetivo",
            item: "objetivo",
            isRequired: true,
            placeholder: "Se debe escribir el objetivo macro que tiene el producto /gerencia, el que aparece en el One-page.",
          },
        ]
    },
    {
      label: "KRs",
      item: "krs",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Si aplica, por favor menciona el KR específico al cual le aportará este proyecto/iniciativa y el Q al que corresponde.",
    },
    {
      label: "Estrategia macro",
      item: "estrategia_macro",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Se debe escribir la estrategia macro que tiene el producto / gerencia, la que aparece en el One-page",
    },
    {
      label:
        "¿A quién le vamos a hablar con esta iniciativa? Market place (adressable): ",
      item: "adressable",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Menciona la audiencia identificada desde el market place a la cuál el vamos a hablar.",
    },
    {
      label:
        "¿A quién le vamos a hablar con esta iniciativa? Perfil de la audiencia / Buyer Persona ",
      item: "audiencia",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Realiza una breve descripción comportamental de las personas a las que les queremos hablar ",
    },
    {
      label: "¿Cuál es el atributo de marca asociado a esta iniciativa? ",
      item: "seasonality_mode",
      type: "multi_select",
      options: [
        {
          value: "capilaridad",
          name: "Capilaridad",
        },
        {
          value: "calidad",
          name: "Calidad",
        },
        {
          value: "transparencia",
          name: "Transparencia",
        },
        {
          value: "sostenibilidad",
          name: "Sostenibilidad",
        },
      ],
      isRequired: false,
      placeholder: "siguientes opciones",
    },
    {
      label:
        "¿Qué espera que la audiencia piense, haga o sienta después de estar expuesta / tener contacto con esta comunicación?",
      item: "audiencia_piensa",
      type: "textarea",
      isRequired: false,
      placeholder: "Que piensa la audiencia",
    },
    {
      label:
        "¿Por qué hoy esto no pasa? ¿Qué impide a nuestra audiencia hacer, pensar o sentir esto? ",
      item: "hoy_no",
      type: "textarea",
      isRequired: false,
      placeholder: "Hoy no esta por ....",
    },
    {
      label:
        "¿Qué tenemos para ofrecer que los motive a hacer lo que queremos que hagan, piense o sienta? (diferencial, beneficio, RTB)",
      item: "que_tenemos",
      type: "textarea",
      isRequired: false,
      placeholder: "Ofrecemos ....",
    },
    {
      label:
        "¿Existe algún competidor local y/o global que esté ofreciendo lo mismo o un producto sustituto y en su criterio lo esté haciendo bien? ¿Cuál? ¿Qué está haciendo? ¿por qué lo está haciendo bien? ",
      item: "competidor_local",
      type: "textarea",
      isRequired: false,
      placeholder: "Nuestros competidores ....",
    },
    {
      label: "Objetivos de medios",
      item: "objetivos_medios",
      type: "array_fields",
      isRequired: false,
      arrayFields: [
        {
          type: "select",
          label: "Tipo de objetivo",
          item: "type",
          isRequired: true,
          placeholder: "Tipo de objetivo",
          options: [
            {
              value: "branding",
              name: "Branding",
            },
            {
              value: "performance",
              name: "Performance",
            },
          ],
        },
        {
          type: "select",
          label: "Etapa",
          item: "etapa",
          isRequired: true,
          placeholder: "Etapa",
          options: [
            {
              value: "awareness",
              name: "Awareness",
            },
            {
              value: "consideracion",
              name: "Consideración",
            },
            {
              value: "conversion",
              name: "Conversión ¿Dónde se cierra la conversión?",
            },
          ],
        },
        {
          type: "textarea",
          label: "Objetivos",
          item: "objetivos",
          isRequired: true,
          placeholder: "Objetivos",
          options: [
            {
              value: "posiciomiento",
              name: "Posicionamiento de marca",
            },
            {
              value: "alcance",
              name: "Alcance",
            },
            {
              value: "trafico",
              name: "Trafico al sitio",
            },
            {
              value: "interacciones",
              name: "Interacciones con los anuncios",
            },
            {
              value: "videos",
              name: "Reproducciones de videos",
            },
            {
              value: "lead",
              name: "Lead",
            },
          ],
        },
      ],
    },
    {
      label: "Presupuesto medios",
      item: "presupuesto_medios",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese presupuesto",
    },
    {
      label: "Presupuesto producciones",
      item: "presupuesto_producciones",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese presupuesto",
    },
    {
      label: "¿A que MDO se carga el ppto?",
      item: "presupuesto_owner",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese el owner presupuesto",
    },
    {
      label:
        "¿Qué equipos (internos y externos) van a participar en este proceso? ¿Cuál es el rol de cada uno?",
      item: "equipo",
      type: "textarea",
      isRequired: true,
      placeholder: "Ingrese el equipo",
    },
    {
      label:
        "¿Para que países se requiren los derechos para utilizar las piezas de la campaña/iniciativa?",
      item: "paises",
      type: "multi_select",
      isRequired: true,
      placeholder: "Agrega el pais",
      options: [
        {
          name: "Colombia",
          value: "colombia",
        },
        {
          name: "Panama",
          value: "panama",
        },
        {
          name: "Guatemala",
          value: "guatemala",
        },
        {
          name: "Salvador",
          value: "salvador",
        },
      ],
    },
    {
      label:
        "¿Por cuánto tiempo se utilizarán las piezas de la iniciativa/iniciativa?",
      item: "tiempo",
      type: "textarea",
      isRequired: true,
      placeholder: "Ingrese el tiempo de la iniciativa",
    },
    {
      label: "Pre-read de negocio y producto",
      item: "preread",
      type: "file",
      isRequired: true,
      placeholder:
        "se puede adjuntar un documento conciso con la información de contexto, de negocio y/o de producto que considere se debe tener en cuenta antes de leer el brief.",
    },
    {
      label: "One page",
      item: "onepage",
      type: "file",
      isRequired: true,
      placeholder: "por favor adjunta el One Page de esta iniciativa",
    },
  ],
  version: 1,
  dateCreate: new Date().toDateString(),
  dateEdit: new Date().toDateString(),
};

export const FormTactic: FormDynamic = {
  id: "master",
  name: "Formulario Brief Tactico",
  user: "masteradmin@bancolombia.com.co",
  fields: [
    {
      label: "¿Pertenece a alguna estrategia de la pirámide?",
      item: "pertenece_estrategia",
      type: "select",
      isRequired: true,
      placeholder: "si pertenece o no",
      options: [
        {
          value: "si",
          name: "Si",
        },
        {
          value: "no",
          name: "No",
        },
      ],
    },
    {
      label: "A qué iniciativa o estrategia de la pirámide pertenece:",
      item: "name",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese la estrategia",
    },
    {
      label: "Describe tu requerimiento:",
      item: "descripcion",
      type: "textarea",
      isRequired: false,
      placeholder: "Describe el requerimiento",
    },
    {
      label: "Fecha de salida",
      item: "fecha_salida",
      type: "date",
      isRequired: true,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "Fecha de estimada de entrega",
      item: "fecha_entrega",
      type: "date",
      isRequired: true,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "Indica nomenclatura para facturación:",
      item: "nomenclatura",
      type: "select",
      isRequired: true,
      placeholder: "Ejemplo: HUMANIDAD_EST_MARCA_MDO01055_MEDIA TEAM",
      options: [
        {
          name: "Agro - MDO01057",
          value: "AGROPLATOSDETEMPORADA_EST_ATRACCIÓN_MDO01057_MEDIATEAM",
        },
        {
          name: "Ciclo de negocio - MDO01062",
          value: "CICLODENEGOCIO_EST_ATRACCIÓN_MDO01062_MEDIATEAM",
        },
        {
          name: "Nomina - MDO01063",
          value: "NOMINA_EST_ATRACCIÓN_MDO01063_MEDIATEAM",
        },
        {
          name: "Pricing - MDO01065",
          value: "PRICING_EST_ATRACCIÓN_MDO01065_MEDIATEAM",
        },
        {
          name: "Pensionados - MDO01064",
          value: "PENSIONADOS_EST_ATRACCIÓN_MDO01064_MEDIATEAM",
        },
        {
          name: "Inversiones - MDO01077",
          value: "INVERSIONES_EST_ATRACCIÓN_MDO01077_MEDIATEAM",
        },
        {
          name: "Independientes - MDO01078",
          value: "INDEPENDIENTES_EST_ATRACCIÓN_MDO01078_MEDIATEAM",
        },
        {
          name: "Consumo y preaprobado - MDO01097",
          value: "CONSUMOYPREAPROBADO_EST_ATRACCIÓN_MDO01097_MEDIATEAM",
        },
        {
          name: "Cuenta de Ahorros - MDO00862",
          value: "CUENTASDEAHORRO_VD_MDO00862_VENTASDIGITALES",
        },
        {
          name: "Bancolombia A la mano - MDO00859",
          value: "BANCOLOMBIAALAMANO_VD_MDO00859_VENTASDIGITALES ",
        },
        {
          name: "Cuentas de Ahorro Panamá - MDO00862",
          value: "CTASDEAHORROPANAMA_VD_MDO00862_VENTASDIGITALES",
        },
        {
          name: "Inversion virtual - MDO00863",
          value: "INVERSIÓNVIRTUAL_VD_MDO00863_VENTASDIGITALES",
        },
        {
          name: "Fondos de Inversion - MDO00861",
          value: "FONDOSDEINVERSIÓN_VD_MDO00861_VENTASDIGITALES",
        },
        {
          name: "TDC - Preaprobados - MDO00855",
          value: "TDCPREAPROBADOS_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "TDC - Solicitudes web - MDO00855",
          value: "TDCSOLICITUDESWEB_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "E-Card - MDO00855",
          value: "E-CARD_VD_MDO00855_VENTASDIGITALES",
        },
        {
          name: "Libre Inversion - Preaprobados - MDO00856",
          value: "LIBREINVERSIÓNPREAPROBADOS_VD_MDO00856_VENTASDIGITALES",
        },
        {
          name: "Libre inversion - Solicitudes web - MDO00856",
          value: "LIBREINVERSIÓNSOLICITUDESWEB_VD_MDO00856_VENTASDIGITALES",
        },
        {
          name: "Libranza - MDO00857",
          value: "LIBRANZA_VD_MDO00857_VENTASDIGITALES",
        },
        {
          name: "Crediagil - MDO00858",
          value: "CREDIAGIL_VD_MDO00858_VENTASDIGITALES",
        },
        {
          name: "Hipotecario - MDO01041",
          value: "HIPOTECARIO_VD_MDO01041_VENTASDIGITALES",
        },
        {
          name: "Seguro Mascotas - MDO00864",
          value: "SEGUROMASCOTAS_VD_MDO00864_VENTASDIGITALES",
        },
        {
          name: "A la mano (Media Team) - MDO01073",
          value: "ALAMANO_VD_MDO01073_MEDIATEAM",
        },
        {
          name: "Colombianos en el exterior (Media Team) - MDO01099",
          value: "COLOMBIANOSENELEXTERIOR_VD_MDO01099_MEDIATEAM",
        },
        {
          name: "Gamming (Media team) - MDO01103",
          value: "GAMMING_VD_MDO01103_MEDIATEAM",
        },
        {
          name: "Remesas (Media team) - MDO01104",
          value: "REMESAS_VD_MDO01104_MEDIATEAM",
        },
        {
          name: "Tarjeta de crédito única - MDVD0001",
          value:
            "TARJETAUNICA_VD_MDO1108_VENTASDIGITALES (ORDEN INTERNA NO EXISTE MANEJO PROPIO TEMPORAL)",
        },
        {
          name: "Encadenamientos Productivos - MDO01066",
          value: "ENCADENAMIENTOS_EST_USO_MDO01066_MEDIATEAM ",
        },
        { name: "Pyme - MDO01067", value: "PYME_EST_USO_MDO01067_MEDIATEAM" },
        {
          name: "Endeudamiento responsable - MDO01076",
          value: "ENDEUDAMIENTO_EST_USO_MDO01076_MEDIATEAM",
        },
        {
          name: "Movilidad Pública - MDO01079",
          value: "MOVILIDADPUBLICA_EST_USO_MDO01079_MEDIATEAM",
        },
        {
          name: "Aceptación Comercios  - MDO01080",
          value: "ACEPTACIONCOMERCIOS_EST_USO_MDO01080_MEDIATEAM",
        },
        {
          name: "Recaudos y pagos de facturas - MDO01081",
          value: "RECAUDOS_EST_USO_MDO01081_MEDIATEAM",
        },
        {
          name: "Dirección y adopción digital - MDO01105",
          value: "ADOPCIONDIGITAL_EST_USO_MDO01105_MEDIATEAM",
        },
        {
          name: "Ofertas y Alianzas - MDO01087",
          value: "OFERTASYALIANZAS_EST_USO_MDO01087_MEDIATEAM",
        },
        {
          name: "Bank as service - MDO01089",
          value: "BAAS_EST_USO_MDO01089_MEDIATEAM",
        },
        {
          name: "Factoring  - MDO01092",
          value: "FACTORING_EST_USO_MDO01092_MEDIATEAM",
        },
        {
          name: "Impuestos - MDO01093",
          value: "IMPUESTOS_EST_USO_MDO01093_MEDIATEAM",
        },
        {
          name: "Comercios internacionales - MDO01094",
          value: "COMERCIOSINTERNACIONALES_EST_USO_MDO01094_MEDIATEAM",
        },
        {
          name: "Día a Día  - MDO01098",
          value: "DIAADIA_EST_USO_MDO01098_MEDIATEAM",
        },
        {
          name: "Humanidad - MDO01055",
          value: "HUMANIDAD_EST_MARCA_MDO01055_MEDIATEAM",
        },
        {
          name: "Sostenibiliad - Poseidón - MDO01056",
          value: "SOSTENIBILIDAD_EST_MARCA_MDO01056_MEDIATEAM",
        },
        {
          name: "Fútbol - MDO01084",
          value: "FUTBOL_EST_MARCA_MDO01084_MEDIATEAM",
        },
        {
          name: "Bienestar financiero - MDO01074",
          value: "BIENESTARFINANCIERO_EST_MARCA_MDO01074_MEDIATEAM",
        },
        {
          name: "Des-enredados  - MDO01106",
          value: "DES-ENREDADOS_EST_MARCA_MDO01106_MEDIATEAM",
        },
        {
          name: " Preferencial y banca privada   - MDO01068",
          value: "PREFERENCIALYBCAPRIVADA_EST_FIDELIZACIÓN_MDO01068_MEDIATEAM",
        },
        {
          name: "Fidelización - MDO01070",
          value: "FIDELIZACIÓN_EST_FIDELIZACIÓN_MDO01070_MEDIATEAM",
        },
        {
          name: "Puntos Colombia - MDONEGOCIO",
          value: "PUNTOSCOLOMBIA_EST_FIDELIZACIÓN_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "Seguros - MDONEGOCIO",
          value: "SEGUROS_EST_FIDELIZACIÓN_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "Plus Alto - MDONEGOCIO",
          value: "PLUSALTO_EST_FIDELIZACION_MDONEGOCIO_NEGOCIO",
        },
        {
          name: "TU360 Awarness  - MDO1109",
          value: "TU360MARCA_ECOSISTEMAS_MDO01109_MEDIATEAM",
        },
        {
          name: "Tu360 Inmobiliario, vivienda y constructor - MDO01072",
          value: "TU360INMOBILIARIO_ECOSISTEMAS_MDO01072_MEDIATEAM",
        },
        {
          name: "Tu360 Compras - MDO01082",
          value: "TU360COMPRAS_ECOSISTEMAS_MDO01082_MEDIATEAM",
        },
        {
          name: "Tu360 Movilidad - MDO01083",
          value: "TU360MOVILIDAD_ECOSISTEMAS_MDO01083_MEDIATEAM",
        },
        {
          name: "Tu360 Negocios - MDO01102",
          value: "TU360NEGOCIOS_ECOSISTEMAS_MDO01102_MEDIATEAM",
        },
      ],
    },
    {
      label: "¿A qué marca pertenece la iniciativa?",
      item: "marca",
      type: "multi_select",
      isRequired: true,
      placeholder: "la marca a generar la iniciativa",
      options: [
        {
          value: "bancolombia",
          name: "Bancolombia",
        },
        {
          value: "bancoagricola",
          name: "Bancoagricola",
        },
        {
          value: "banistmo",
          name: "Banitmo",
        },
        {
          value: "bam",
          name: "Bam",
        },
        {
          value: "renting colombia",
          name: "Renting Colombia",
        },
        {
          value: "nequi",
          name: "Nequi",
        },
      ],
    },
    {
      label:
        "¿A que ciclo de vida de mercadeo pertenece la iniciativa/iniciativa?",
      item: "ciclo",
      type: "multi_select",
      isRequired: true,
      placeholder: "el ciclo de vida",
      options: [
        {
          name: "Uso",
          value: "uso",
        },
        {
          name: "Atracción y Profundización",
          value: "atraccion y profundizacion",
        },
        {
          name: "Integración del Usuario",
          value: "integración del usuario",
        },
        {
          name: "Ecosistemas",
          value: "ecosistemas",
        },
        {
          name: "Ventas Digitales",
          value: "ventas digitales",
        },
        {
          name: "Marca",
          value: "marca",
        },
        {
          name: "Fidelización",
          value: "fidelizacion",
        },
      ],
    },
    {
      label: "¿Cuándo inicia la iniciativa?",
      item: "fecha_inicio",
      type: "date",
      isRequired: false,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "¿Cuándo termina la iniciativa/iniciativa?",
      item: "fecha_fin",
      type: "date",
      isRequired: false,
      placeholder: "DD/MM/AAAA",
    },
    {
      label: "Objetivo de mercadeo:",
      item: "objetivo",
      type: "array_fields",
      isRequired: false,
        arrayFields: [
          {
            type: "textarea",
            label: "Objetivo",
            item: "objetivo",
            isRequired: true,
            placeholder: "Se debe escribir el objetivo macro que tiene el producto /gerencia, el que aparece en el One-page.",
          },
        ]
    },
    {
      label: "KRs",
      item: "krs",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Si aplica, por favor menciona el KR específico al cual le aportará este proyecto/iniciativa y el Q al que corresponde.",
    },
    {
      label: "Estrategia macro",
      item: "estrategia_macro",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Se debe escribir la estrategia macro que tiene el producto / gerencia, la que aparece en el One-page",
    },
    {
      label:
        "¿A quién le vamos a hablar con esta iniciativa? Market place (adressable): ",
      item: "adressable",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Menciona la audiencia identificada desde el market place a la cuál el vamos a hablar.",
    },
    {
      label:
        "¿A quién le vamos a hablar con esta iniciativa? Perfil de la audiencia / Buyer Persona ",
      item: "audiencia",
      type: "textarea",
      isRequired: false,
      placeholder:
        "Realiza una breve descripción comportamental de las personas a las que les queremos hablar ",
    },
    {
      label: "¿Cuál es el atributo de marca asociado a esta iniciativa? ",
      item: "seasonality_mode",
      type: "multi_select",
      options: [
        {
          value: "capilaridad",
          name: "Capilaridad",
        },
        {
          value: "calidad",
          name: "Calidad",
        },
        {
          value: "transparencia",
          name: "Transparencia",
        },
        {
          value: "sostenibilidad",
          name: "Sostenibilidad",
        },
      ],
      isRequired: false,
      placeholder: "siguientes opciones",
    },
    {
      label:
        "¿Qué espera que la audiencia piense, haga o sienta después de estar expuesta / tener contacto con esta comunicación?",
      item: "audiencia_piensa",
      type: "textarea",
      isRequired: false,
      placeholder: "Que piensa la audiencia",
    },
    {
      label:
        "¿Por qué hoy esto no pasa? ¿Qué impide a nuestra audiencia hacer, pensar o sentir esto? ",
      item: "hoy_no",
      type: "textarea",
      isRequired: false,
      placeholder: "Hoy no esta por ....",
    },
    {
      label:
        "¿Qué tenemos para ofrecer que los motive a hacer lo que queremos que hagan, piense o sienta? (diferencial, beneficio, RTB)",
      item: "que_tenemos",
      type: "textarea",
      isRequired: false,
      placeholder: "Ofrecemos ....",
    },
    {
      label:
        "¿Existe algún competidor local y/o global que esté ofreciendo lo mismo o un producto sustituto y en su criterio lo esté haciendo bien? ¿Cuál? ¿Qué está haciendo? ¿por qué lo está haciendo bien? ",
      item: "competidor_local",
      type: "textarea",
      isRequired: false,
      placeholder: "Nuestros competidores ....",
    },
    {
      label: "Objetivos de medios",
      item: "objetivos_medios",
      type: "array_fields",
      isRequired: false,
      arrayFields: [
        {
          type: "select",
          label: "Tipo de objetivo",
          item: "type",
          isRequired: true,
          placeholder: "Tipo de objetivo",
          options: [
            {
              value: "branding",
              name: "Branding",
            },
            {
              value: "performance",
              name: "Performance",
            },
          ],
        },
        {
          type: "select",
          label: "Etapa",
          item: "etapa",
          isRequired: true,
          placeholder: "Etapa",
          options: [
            {
              value: "awareness",
              name: "Awareness",
            },
            {
              value: "consideracion",
              name: "Consideración",
            },
            {
              value: "conversion",
              name: "Conversión ¿Dónde se cierra la conversión?",
            },
          ],
        },
        {
          type: "textarea",
          label: "Objetivos",
          item: "objetivos",
          isRequired: true,
          placeholder: "Objetivos",
          options: [
            {
              value: "posiciomiento",
              name: "Posicionamiento de marca",
            },
            {
              value: "alcance",
              name: "Alcance",
            },
            {
              value: "trafico",
              name: "Trafico al sitio",
            },
            {
              value: "interacciones",
              name: "Interacciones con los anuncios",
            },
            {
              value: "videos",
              name: "Reproducciones de videos",
            },
            {
              value: "lead",
              name: "Lead",
            },
          ],
        },
      ],
    },
    {
      label: "Presupuesto medios",
      item: "presupuesto_medios",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese presupuesto",
    },
    {
      label: "Presupuesto producciones",
      item: "presupuesto_producciones",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese presupuesto",
    },
    {
      label: "¿A que MDO se carga el ppto?",
      item: "presupuesto_owner",
      type: "text",
      isRequired: true,
      placeholder: "Ingrese el owner presupuesto",
    },
    {
      label:
        "¿Qué equipos (internos y externos) van a participar en este proceso? ¿Cuál es el rol de cada uno?",
      item: "equipo",
      type: "textarea",
      isRequired: true,
      placeholder: "Ingrese el equipo",
    },
    {
      label:
        "¿Para que países se requiren los derechos para utilizar las piezas de la campaña?",
      item: "paises",
      type: "multi_select",
      isRequired: true,
      placeholder: "Agrega el pais",
      options: [
        {
          name: "Colombia",
          value: "colombia",
        },
        {
          name: "Panama",
          value: "panama",
        },
        {
          name: "Guatemala",
          value: "guatemala",
        },
        {
          name: "Salvador",
          value: "salvador",
        },
      ],
    },
    {
      label:
        "¿Por cuánto tiempo se utilizarán las piezas de la iniciativa/iniciativa?",
      item: "tiempo",
      type: "textarea",
      isRequired: true,
      placeholder: "Ingrese el tiempo de la iniciativa",
    },
    {
      label: "Pre-read de negocio y producto",
      item: "preread",
      type: "file",
      isRequired: true,
      placeholder:
        "se puede adjuntar un documento conciso con la información de contexto, de negocio y/o de producto que considere se debe tener en cuenta antes de leer el brief.",
    },
    {
      label: "One page",
      item: "onepage",
      type: "file",
      isRequired: true,
      placeholder: "por favor adjunta el One Page de esta iniciativa",
    },
  ],
  version: 1,
  dateCreate: new Date().toDateString(),
  dateEdit: new Date().toDateString(),
};

export const FormLogin: FormDynamic = {
  id: "login",
  name: "Formulario Login",
  user: "masteradmin@bancolombia.com.co",
  fields: [
    {
      label: "Correo",
      item: "username",
      type: "email",
      isRequired: true,
      placeholder: "ejemplo@ejemplo.com",
    },
    {
      label: "Contraseña",
      item: "password",
      type: "password",
      isRequired: true,
      placeholder: "*********",
    },
  ],
  version: 1,
  dateCreate: new Date().toDateString(),
  dateEdit: new Date().toDateString(),
};
